import styled, { css } from 'styled-components';
import {
    spaceMixin,
    mediaMixin,
} from '@zillow/constellation';

export const StyledContainerMobile = styled.div`
    margin-top: auto;
    padding-top: ${spaceMixin('sm')};
    ${mediaMixin('lg', css`
        display: none;
    `)};
`;

export const StyledContainerDesktop = styled.div`
    margin-top: auto;
    padding-top: ${spaceMixin('md')};
    display: none;
    ${mediaMixin('lg', css`
        display: block;
    `)};
`;
